import React from "react";

import { Box, Button, Flex, Link, Text, WrapItem } from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";

import { ADIF_RED } from "common/components/EstadoComunicacionIndicator";

type IProps = {
	name: string;
	path: boolean;
	title?: string;
	badgeCount?: number;
};

export const TableButton: React.FC<IProps> = (props) => {
	const { name, path, title, badgeCount } = props;

	const getHRef = () => {
		switch (name) {
			case "Inspección":
				return "/portfolio/inspeccion";
			case "Localización":
				return "/portfolio/localizacion";
			case "Tipología":
				return "/portfolio/tipologia";
			case "E. Conservación":
				return "/portfolio/nec";
			case "E. Energética":
				return "/portfolio/nee";
			case "Accesibilidad":
				return "/portfolio/nae";
			case "C. Normativa":
				return "/portfolio/ncn";
			case "Cert. IP":
				return "/portfolio/certificacion";
			case "Cert. IB":
				return "/portfolio/certificacion-basicas";
			case "Comunicaciones":
				return "/portfolio/comunicaciones";
			default:
				return "/portfolio/inspeccion";
		}
	};

	return (
		<React.Fragment>
			<WrapItem>
				<Link as={ReactRouterLink} to={getHRef()} _hover={{ textDecoration: "none" }}>
					<Box position="relative">
						<Button
							size="md"
							borderRadius="5px"
							h="auto"
							minH="2rem"
							variant="outline"
							borderWidth="1.5px"
							borderColor={path ? "gray.500" : "gray.300"}
							_hover={path ? {} : { bgColor: "gray.100" }}
							title={title ?? name}
						>
							<Text textStyle="body3" color={path ? "gray.700" : "gray.400"}>
								{name}
							</Text>
						</Button>
						{!!badgeCount && (
							<Flex
								position="absolute"
								top="-.4rem"
								right="-.4rem"
								minW="1.1rem"
								h="1.1rem"
								px=".25rem"
								borderRadius="full"
								bg={ADIF_RED}
								border="2px solid white"
								alignItems="center"
								justifyContent="center"
							>
								<Text fontSize=".625rem" lineHeight="1" fontWeight="bold" color="white">
									{badgeCount > 99 ? "99+" : badgeCount}
								</Text>
							</Flex>
						)}
					</Box>
				</Link>
			</WrapItem>
		</React.Fragment>
	);
};
